<template>
    <div id="notif">
        <ul id="notifications" class="">
            <li class="nav-item dropdown profile-lnk">
                <a @click.prevent="openProfileLinks" class="nav-link dropdown-toggle text-nowrap px-3 avatar" aria-controls="user-actions" aria-expanded="false" role="button">
                    <span class="font-avatar adj rounded-circle mr-2" v-html="user_letter"></span>
                    <span class="uname d-inline-block d-sm-none"> {{user_data.first_name + ' ' + user_data.last_name}}</span>
                </a>
                <div id="user-actions" class="d-none dropdown-menu dropdown-menu-small collapse">
                    <router-link to="/my-account" class="dropdown-item" target="_self" role="menuitem" routertag="a" event="click">
                        <i class="fas fa-user-circle"></i>Fiók adatok</router-link>
                    <router-link to="/my-account/change-password" class="dropdown-item" target="_self" role="menuitem" routertag="a" event="click">
                        <i class="fas fa-key"></i> Jelszóváltoztatás</router-link>
                    <div role="separator" class="dropdown-divier"></div>
                    <a href="#" target="_self" class="dropdown-item text-danger" role="menuitem" routertag="a" @click="logout">
                        <i class="fas fa-sign-out-alt text-danger"></i> Kilejentkezés</a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default{
        name: 'Notifications',
        data(){
            return{

            }
        },
        computed: {
            ...mapGetters([
                'user',
                'notifications',
            ]),
            user_data: {
                get: function() {
                    return this.user ? this.user : {};
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            user_letter() {
                if(this.user_data && this.user_data.last_name) {
                    return this.user_data.last_name[0].toUpperCase();
                } else {
                    return this.user_data.first_name[0].toUpperCase();
                }
            },
            notification_data: {
                get: function() {
                    return this.notifications;
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        methods: {
            ...mapActions([
                'getNotifications',
            ]),
            openProfileLinks: function(){
                $( "#user-actions" ).toggleClass( "d-block", "d-none" );
                $( "#user-actions" ).toggleClass( "d-none", "d-block" );
            },
            logout: function(){
                this.$store.dispatch('logout').then((response) => {
                   if(response.data){
                       this.$messaging.DisplaySuccess('', 'Ön kilépett a rendszerből.');
                       this.$emit('onLoggedOut');
                       this.$store.commit('setOnLogoutProgress', false);
                   }else{
                       this.$messaging.DisplayError('Logout error', 'Hiba történt!');
                   }
                }).catch((err) => {
                    this.$messaging.DisplayError('Logout error', 'Sikertelen kijelentkezés!');
                });
            },

        },
        mounted() {
            this.getNotifications();
        },
        watch: {
            $route: function(newVal) {
                if(newVal.path.indexOf('my-account') > -1) {
                    this.openProfileLinks();
                }
            },
            user: {
                handler: function(newVal) {
                    this.user_data = newVal;
                },
                deep: true,
            },
            notifications: {
                handler: function(newVal) {
                    this.notification_data = newVal;
                }
            }
        }
    }
</script>

<style lang="scss">
    html, body{
        height: 100%;
    }
    #notifications{
        cursor: pointer;
    }
    #notif{
        width: 234px;
    }
    .notif-bell{
        padding: 10px 20px 10px 20px !important;
        float: left;
    }
    .fa-bell{
        font-size: 20px;
        color: #c3c7cc;
    }
    .badge-pill{
        position: absolute;
        top: 25px;
        font-size: 9px;
    }
    .avatar img{
        width: 40px;
        height: 40px;
    }
    .avatar{
        color: rgba(0,0,0,.5);
        font-size: .8125rem;
        font-weight: 400;
    }
    .dropdown {
        padding-bottom: 24px;
    }

    .dropdown-toggle::after {
        position: absolute;
        top: 35px;
        right: 0px;
        margin: 0px;
        padding: 0px;
    }

    .profile-lnk{
        height: auto;
        position: relative;
        overflow: hidden;

        .uname {
            position: relative;
            top: 9px;
        }
    }
    .profile-lnk i{
        position: relative;
        top: 1px;
        left: 3px;
    }
    .navbar-nav .nav-link {

    }
    #user-actions{
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        position: relative;
        top: 17px;
        width: 82%;
        left: 37px;
        border: 1px solid rgba(0,0,0,.15);
        border-top: 0px;
        margin: 5px 1px 1px 1px;
    }
    #user-actions a{
        color: rgba(0,0,0,.5);
        font-size: .8125rem;
        font-weight: 400;
    }
    #user-actions a i{
        color: rgba(0,0,0,.5);
        padding: 5px;
    }

    @media (max-width: 767px) {
        .notif-bell{
            margin-top: 5px;
            margin-left: 13px;
            padding-left: 5px;
            padding-right: 20px;
        }
    }

    .font-avatar {
        font-size: 20px;
        background-color: #428af5f7;
        padding: 4px 10px 6px 10px;
        color: white;
        position: relative;
        top: 3px;
        border-radius: 15px;
        font-weight: 500;
    }

    .adj {
        position: relative;
        top: 12px;
        left: -7px;
    }

    .dep-name {
        position: relative;
        left: -13px;
    }

</style>